import React from 'react';
import { CheckCircle2Icon, LockIcon, MailIcon, WalletIcon } from 'lucide-react';
import { trustItems } from '../data/content';
const icons = {
  lock: LockIcon,
  check: CheckCircle2Icon,
  money: WalletIcon,
  mail: MailIcon
};
interface TrustIconsProps {
  className?: string;
}
export function TrustIcons({
  className = ''
}: TrustIconsProps) {
  return <ul className={`flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-semibold text-neutral-500 ${className}`} data-id="element-170" data-mp="1zvz2sjghrbh8">
      {trustItems.map(item => {
      const Icon = icons[item.icon];
      return <li key={item.label} className="inline-flex items-center gap-2" data-id="element-171" data-mp="1lxr4o87py44h">
            <Icon className="h-4 w-4 shrink-0 text-pink-600" aria-hidden="true" data-id="element-172" data-mp="1gz7g001qqe8f" />
            {item.label}
          </li>;
    })}
    </ul>;
}